module.exports = __webpack_public_path__ + "img/logo_DOUBLE_SCOOP_REBATE.e3b095ac.svg";